"use client";
import { createRESTStore } from "@stores/shared/createRESTStore";
import apiClient from "@services/api/apiClient";
import API from "@config/shared/api-paths";

// Stable sort (ES2019+ guarantees this) — sticky items float to the top,
// otherwise the API's own ordering is preserved.
const sortNotifications = (items) =>
  [...items].sort((a, b) => (b.sticky ? 1 : 0) - (a.sticky ? 1 : 0));

const useNotificationsStore = createRESTStore({
  entityName: "notifications",
  apiPaths: {
    fetch: API.FRONTEND.NOTIFICATIONS_ME,
    update: API.FRONTEND.NOTIFICATIONS_ME,
  },
  initialState: [],
  processResponse: {
    fetch: (response) => sortNotifications(response.items || response),
  },
  additionalActions: (set, get) => ({
    toggleSeen: async (id, successCallback, errorCallback) => {
      try {
        await apiClient(
          `${get().apiPaths.update}/${id}/toggle-seen`,
          {
            method: "PUT",
          }
        );
        successCallback();
      } catch (error) {
        errorCallback(error);
      }
    },
    acknowledge: async (id, successCallback, errorCallback) => {
      try {
        await apiClient(
          `${get().apiPaths.update}/${id}/acknowledge`,
          {
            method: "PUT",
          }
        );
        set((state) => ({
          ...state,
          notifications: state.notifications.map((notification) =>
            notification.id === id
              ? { ...notification, acknowledged: true }
              : notification
          ),
        }));
        successCallback?.();
      } catch (error) {
        errorCallback?.(error);
      }
    },
    deleteOne: async (id, successCallback, errorCallback) => {
      try {
        await apiClient(`${get().apiPaths.update}/${id}`, {
          method: "DELETE",
        });
        set((state) => ({
          ...state,
          notifications: state.notifications.filter(
            (notification) => notification.id !== id
          ),
        }));
        successCallback();
      } catch (error) {
        errorCallback(error);
      }
    },
  }),
});

export default useNotificationsStore;
